import { Typogaphy } from 'vnetwork-ui'
import Logo from '../Logo'
import { useAppStore } from '@/stores/useAppStore'

const BrandName = () => {
    const { setSideBarFull, sideBarFull } = useAppStore()

    return (
        <div
            className={`items-center gap-2 ${sideBarFull ? 'justify-between' : 'justify-center md:pt-4 pt-0'} flex cursor-pointer`}
            onClick={() => {
                setSideBarFull(!sideBarFull)
            }}
        >
            {
                <div className="flex items-center gap-2">
                    <div
                        className={`items-center justify-center lg:flex md:flex hidden`}
                    >
                        <Logo className="w-6 h-6" />
                    </div>
                    {sideBarFull && (
                        <div>
                            <Typogaphy
                                size="medium"
                                className="text-primary font-bold"
                            >
                                DataCentral
                            </Typogaphy>

                            {/* <Typogaphy className="text-[9px] mt-1 leading-3 font-normal text-gray-87">
                                Version 4.0
                                <span className="block">
                                    ©2024 VNETWORK JSC
                                </span>
                            </Typogaphy> */}
                        </div>
                    )}
                </div>
            }

            {/* {sideBarFull && (
                <div className="p-2 cursor-pointer block">
                    <DownIcons className="icon-small rotate-90" />
                </div>
            )} */}
        </div>
    )
}

export default BrandName
